import {useTranslation} from "react-i18next";

function BillRow({ children, label, value }) {
  const {t} = useTranslation()
  
  return (
    <div className="flex mdmax:container">
      {
        children
          ? children
          : <>
            <p className="py-[12px] text-left mdmax:flex-1 text-[#666]">{t(label)}</p>
            <p className="py-[12px] mdmax:flex-1 md:w-[140px]">{value}</p>
          </>
      }
    </div>
  );
}

export default function BillCard({ isEdit, detail = {} }) {
  const { t } = useTranslation();
  
  return (
    <div className="px-[15px] flex mdmax:flex-col">
      {
        !isEdit
        && <div className="pt-[15px] pb-[5px] md:hidden">
          <p className="mb-[8px] text-[#666]">{t('订单号：')} {detail.orderNo}</p>
          <p className="text-[#666]">{t('下单时间')}：{detail.createTime}</p>
        </div>
      }
      <div className="w-[160px] h-[160px] mr-[3%] mdmax:hidden flex-none"></div>
      <div className="flex-1 flex flex-col items-end md:border-t border-[#eee] text-right
                      mdmax:divide-y divide-[#eee] border-[#d4d4d4] md:py-[30px]">
        {/*<BillRow label="配送方式" value="德邦物流"/>*/}
        <BillRow label="商品总计" value={`$${detail.prodTotalPrice}`}/>
        <BillRow label="优惠券" value={`$${detail.useCouponAmount}`}/>
        {/*<BillRow label="商品优惠金额" value="$12"/>*/}
        <BillRow label="运费" value={`$${detail.transportFee || 0}`}/>
        <BillRow>
          <p className="py-[15px] text-[#666]">{t('应付金额')}</p>
          <p className="py-[15px] mdmax:flex-1 md:w-[140px] text-[16px] mdmax:text-[#F43E38] font-bold">${detail.receivable}</p>
        </BillRow>
      </div>
    </div>
  );
}
